"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var useSelectOptions = function useSelectOptions() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = props.options;
  options.filter(function (product) {
    return product.alternativeVariantAvailable;
  }).forEach(function (product) {
    var alternativeVariantAvailable = product.alternativeVariantAvailable;
    if (alternativeVariantAvailable) {
      product.label = "".concat(product.name, "*");
    }
  });
  var onChange = props.onChange,
    label = props.label;
  var setValue = function setValue(number) {
    onChange(number);
  };
  var selectProps = {
    options: options,
    value: props.value,
    onChange: function onChange(val) {
      setValue(val);
    },
    label: label,
    placeholder: label
  };
  return {
    selectProps: selectProps,
    controller: {
      selectProps: selectProps
    }
  };
};
var _default = useSelectOptions;
exports["default"] = _default;